import React, { useEffect, useRef, useState } from "react";
import styles from "styles.module.css";
import { useTranslation } from "react-i18next";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { addDays, addMonths } from "date-fns";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
import {
	getRegistrationOverviewApi,
	RegistrationOverviewParams,
} from "api/registration";
import { registrationOverviewGridColumns } from "./utils/OverviewGridColumns";
import OverviewFilter from "./utils/OverviewFilter";
import { useLocation, useNavigate } from "react-router";
import { useMenuItemStore } from "store/menuItem";
import { findMenuItemByPath } from "utils/helper";
import { getPageAccessApi } from "api/menu";
import { PageAccessByMenu } from "interface/user";
import { PageTypePath } from "utils/pages";

const RegistrationOverviewPage: React.FC = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const { menuItems } = useMenuItemStore();

	const currentPath = location.pathname;

	const [pageAccess, setPageAccess] = useState<PageAccessByMenu | null>(null);
	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);

	const [filterOptions, setFilterOptions] =
		useState<RegistrationOverviewParams>({
			registrationTimeFrom: new Date(), //addDays(new Date(), -2),
			registrationTimeTo: new Date(),
			landingTimeFrom: null, //addDays(new Date(), -2),
			landingTimeTo: null, //new Date(),
		});

	useEffect(() => {
		const pageHandler = async () => {
			const menu = findMenuItemByPath(menuItems, currentPath);
			try {
				if (!pageAccess && menu) {
					const access = await getPageAccessApi(menu.id);
					setPageAccess(access);
				}
			} catch (error) {
				console.error("Error fetching page access:", error);
			}
		};
		pageHandler();
	}, [currentPath, menuItems, pageAccess]);

	const exportGridAsPDF = () => {
		if (pdfRef.current !== null) {
			pdfRef.current.save();
		}
	};

	const exportGridAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};

	const handleLandingNote = (props: any) => {
		window.open(
			`/${PageTypePath.FisheryDepartmentLandingNotes}/${props.registrationId}`,
		);
	};

	const handleSalesNote = (props: any) => {
		console.log(props);
		window.open(
			`/${PageTypePath.FisheryDepartmentSalesNotes}/${props.registrationId}`,
		);
	};
	return (
		<div className={styles.PageContainer}>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>
					{t("RegistrationOverview")}
				</legend>
			</div>
			<div>
				<OverviewFilter
					filterOptions={filterOptions}
					setFilterOptions={setFilterOptions}
					exportAsPDF={exportGridAsPDF}
					exportAsExcel={exportGridAsExcel}
				/>
			</div>
			<div style={{ marginTop: 30 }}>
				<GridWithGroupPaging
					// dataKey="registrationId"
					gridColumns={registrationOverviewGridColumns({
						onViewLandingNote: handleLandingNote,
						onViewSalesNote: handleSalesNote,
					})}
					exportGridAsPDFRef={pdfRef}
					exportGridAsExcelRef={excelRef}
					apiMethod={(params) =>
						getRegistrationOverviewApi(params).then((res) => res.data ?? [])
					}
					filter={filterOptions}
					itemAboveHeight={100}
					pageable={false}
					// hideVirtualScroll={true}
				/>
			</div>
		</div>
	);
};

export default RegistrationOverviewPage;
